import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/site/Form";
import { api, errMsg } from "@/lib/api";
import { AuthShell } from "./Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [err, setErr] = useState(null);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (ex) {
      setErr(errMsg(ex));
    }
  };
  return (
    <AuthShell title="Reset your password">
      {done ? (
        <p className="mt-4 text-slate-700" data-testid="forgot-done">If an account exists for that address, we've sent a link to choose a new password. It expires in 1 hour.</p>
      ) : (
        <form onSubmit={submit} className="mt-5 space-y-4" data-testid="forgot-form">
          <Field label="Email" htmlFor="email"><input id="email" type="email" className="field-input" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" /></Field>
          {err && <p className="text-sm text-destructive" role="alert">{err}</p>}
          <Button type="submit" className="w-full" data-testid="forgot-submit-button">Send reset link</Button>
        </form>
      )}
      <Link to="/dealer/login" className="link mt-4 block text-sm">Back to sign in</Link>
    </AuthShell>
  );
}
